import { createContext, useContext, useEffect } from "react";

/** Lets a page of the parent portal hide the top bar, for example the outage page. */
export const ParentChromeContext = createContext({ setNavbarHidden: () => {} });

/** Hides the top bar of the parent portal while the calling component is shown. */
export function useHideParentNavbar() {
  const { setNavbarHidden } = useContext(ParentChromeContext);
  useEffect(() => {
    setNavbarHidden(true);
    return () => setNavbarHidden(false);
  }, [setNavbarHidden]);
}
